export default function MapPin({ pin, scale = 1, drop = false, delay = 0, onTap, name, small = false, flip, labelDy = 0 }) {
  const v = pin.is_user;
  const k = small ? 0.68 : v ? 1.18 : 1;
  const tap = onTap
    ? (e) => {
        e.stopPropagation();
        onTap(pin);
      }
    : undefined;
  return (
    <span
      data-testid={`map-pin-${pin.label}`}
      className="map-pin"
      onClick={tap}
      style={{ left: `${pin.x}%`, top: `${pin.y}%`, "--pin-scale": scale * k, zIndex: v ? 4 : small ? 2 : 3, pointerEvents: onTap ? "auto" : "none", cursor: onTap ? "pointer" : undefined }}
    >
      <span className={`block ${drop ? "pin-drop" : ""}`} style={drop ? { animationDelay: `${delay}ms` } : undefined}>
        <svg width="26" height="36" viewBox="0 0 26 36" aria-hidden="true" className="block overflow-visible">
          {v && <circle cx="13" cy="12.8" r="16" fill="none" stroke="var(--pin-v)" strokeWidth="1.5" opacity="0.9" />}
          <path
            d="M13 36C13 36 25.5 21.8 25.5 12.8C25.5 5.9 19.9 0.5 13 0.5C6.1 0.5 0.5 5.9 0.5 12.8C0.5 21.8 13 36 13 36Z"
            fill={v ? "var(--pin-v)" : "var(--pin)"}
            stroke={v ? "var(--bg)" : "rgba(0,0,0,0.2)"}
            strokeWidth="1"
          />
          <text x="13" y="17.2" textAnchor="middle" fontSize="12.5" fontWeight="600" fontFamily="Inter, system-ui, sans-serif" fill={v ? "var(--pin-v-text)" : "var(--pin-text)"}>
            {pin.label}
          </text>
        </svg>
      </span>
      {(v || name) && (
        <span className={`pin-label ${(flip ?? pin.x > 85) ? "pin-label-left" : ""}`} data-testid={v ? "map-pin-toi-label" : `map-pin-label-${pin.label}`} style={labelDy ? { transform: `translateY(${labelDy}px)` } : undefined}>
          {v ? "Toi" : name}
        </span>
      )}
    </span>
  );
}

export function MapDot({ dot, scale = 1, onTap }) {
  return (
    <span
      data-testid={`map-dot-${dot.rank}`}
      className="map-dot"
      style={{ left: `${dot.x}%`, top: `${dot.y}%`, "--pin-scale": scale }}
      onClick={(e) => {
        e.stopPropagation();
        onTap?.(dot);
      }}
    >
      <span className="map-dot-core" />
    </span>
  );
}
